module.exports = __webpack_public_path__ + "img/nav-logo-white.9b68a7df.svg";